import { Route, Routes } from "react-router-dom";
import AboutPage from "./components/Pages/AboutPage";
import BlogPage from "./components/Pages/BlogPage";
import BlogDetailsPage from "./components/Pages/BlogDetailsPage";
import ContactPage from "./components/Pages/ContactPage";
import ErrorPage from "./components/Pages/ErrorPage";
import Home from "./components/Pages/Home";
import PortfolioDetailsPage from "./components/Pages/PortfolioDetailsPage";
import ServiceDetailsPage from "./components/Pages/ServiceDetailsPage";
import ServicesPage from "./components/Pages/ServicesPage";
import TeamPage from "./components/Pages/TeamPage";
import PortfolioPage from "./components/Pages/PortfolioPage";
import TeamDetails from "./components/Pages/TeamDetails";
import CaseStudyShowcaseHome from "./components/Pages/CaseStudyShowcaseHome";
import Layout from "./components/Layout";
import CaseStudyDetailsPage from "./components/Pages/CaseStudyDetailsPage";
import FaqPage from "./components/Pages/FaqPage";
import TermsOfUsePage from "./components/Pages/TermsOfUsePage";
import PrivacyPolicyPage from "./components/Pages/PrivacyPolicyPage";
import ServiceForm from "./components/ServiceForm/ServiceForm";
import Success from "./components/Pages/Success";
import Appointment from "./components/Pages/Appointment";
import Admin from "./components/Admin/Admin";
import Login from "./components/Admin/Login";

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="service" element={<ServicesPage />} />
        <Route path="service-form/:serviceName" element={<ServiceForm />} />
        <Route
          path="service/:serviceDetailsId"
          element={<ServiceDetailsPage />}
        />
        <Route path="portfolio" element={<PortfolioPage />} />
        <Route
          path="portfolio/:portfolioDetailsId"
          element={<PortfolioDetailsPage />}
        />
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/:blogDetailsId" element={<BlogDetailsPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="appointment" element={<Appointment />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="team/:teamDetails" element={<TeamDetails />} />
        <Route
          path="case-study/:caseStudyDetailsId"
          element={<CaseStudyDetailsPage />}
        />
        <Route path="faq" element={<FaqPage />} />
        <Route path="terms" element={<TermsOfUsePage />} />
        <Route path="privacy" element={<PrivacyPolicyPage />} />
      </Route>
      <Route element={<Layout headerVariant="cs-site_header_full_width" />}>
        <Route
          path="case-study-showcase"
          element={<CaseStudyShowcaseHome />}
        />
      </Route>
      <Route path="admin/*" element={<Admin />} />
      <Route path="login" element={<Login />} />
      <Route path="success" element={<Success />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
